module.exports = __webpack_public_path__ + "assets/images/smoke_r.0464ff1c.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/risks/smoke_r.png
// module id = 766
// module chunks = 1